import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeUpdateTherapyPrescriptionMutation as useDeUpdateTherapyPrescriptionMutationType } from "@/modules/patients/detail/therapy-prescription/de/services/__generated__/useDeUpdateTherapyPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useDeUpdateTherapyPrescriptionMutation($input: De_updateTherapyPrescriptionInput!) {
    de_updateTherapyPrescription(input: $input) {
      de_TherapyPrescription {
        id
        ...deTherapyPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeUpdateTherapyPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeUpdateTherapyPrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeUpdateTherapyPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeUpdateTherapyPrescriptionMutation }
